import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { List } from "immutable";
import RestaurantListView from '../components/Restaurant/RestaurantListView';
import {bindActionCreators} from "redux";
import * as basketActions from "../actions/basketActions";
import * as restaurantActions from "../actions/restaurantActions";
import {checkBasketIsEmpty, getLanguagesFromUri} from "../helpers";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {translate} from 'react-i18next';
import Spinner from '../components/Spinner/Spinner';
import {DEFAULT_LANGUAGE} from '../constants';


class RestaurantLayout extends Component {

  constructor(props) {
    super(props);
    this.changeRestaurant = this.changeRestaurant.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  static renderLoading(t) {
    return (
      <Spinner text={t('loading_restaurants')} size="small"/>
    );
  }

  changeRestaurant(data) {
    const {location, language} = this.props;
    let {pathname} = location;
    pathname = pathname.replace(/\/$/, '');
    const lng = language.defaultLanguage || DEFAULT_LANGUAGE;
    const lngFromUrl = getLanguagesFromUri(pathname, lng);
    if (pathname !== '/' && pathname !== `/${lngFromUrl}`) {
      this.props.startSelectedFetchRestaurant();
      this.props.selectedRestaurant(data).then(() => {
        this.props.endSelectedFetchRestaurant();
        const restaurant = this.props.restaurants.list.find((obj) => {
          return obj.id === data;
        });
        const filterType = this.props.filterType || 'pizza';
        this.props.history.push(`/${lng}/${restaurant.name_for_url}/products/${filterType}`);
      });
    } else {
      this.props.selectedWithoutFetchRestaurant(data);
    }
    this.props.clearBasket();
  }

  handleChange(selection) {
    const {basket, t} = this.props;
    if (checkBasketIsEmpty(basket)) {
      return this.changeRestaurant(selection);
    }
    confirmAlert({
      message: t('confirm_restaurant_change'),
      buttons: [
        {
          label: t('continue'),
          onClick: () => this.changeRestaurant(selection),
        },
        {
          label: t('cancel'),
        },
      ],
    });
  };

  render() {
    const { restaurants, classes, t } = this.props;
    const currentRestaurant = restaurants.selectedId ? {'id': restaurants.selectedId} : {};
    if (!List.isList(restaurants.list)) return RestaurantLayout.renderLoading(t);
    return (
      <RestaurantListView
        list={restaurants.list}
        selected={currentRestaurant}
        onChange={this.handleChange}
        classes={classes}
      />
    );
  }
}


RestaurantLayout.propTypes = {
  restaurants: PropTypes.object,
  basket: PropTypes.object,
  classes: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    restaurants: state.restaurants,
    basket: state.basket,
    filterType: state.products.filterType,
    language: state.language
  }
}

function mapDispatchToProps(dispatch) {
  return {
    selectedRestaurant: bindActionCreators(restaurantActions.selectedRestaurant, dispatch),
    startSelectedFetchRestaurant: bindActionCreators(restaurantActions.startSelectedFetchRestaurant, dispatch),
    endSelectedFetchRestaurant: bindActionCreators(restaurantActions.endSelectedFetchRestaurant, dispatch),
    selectedWithoutFetchRestaurant: bindActionCreators(restaurantActions.selectedWithoutFetchRestaurant, dispatch),
    clearBasket: bindActionCreators(basketActions.clearBasket, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('translations')(RestaurantLayout)));


// WEBPACK FOOTER //
// ./src/containers/Restaurant.js